import React, {useEffect} from "react";
import {Card, CardBody, CardHeader, CardHeaderToolbar, ModalProgressBar,} from "../../../_metronic/_partials/controls";
import OrdersTable from "./OrdersTable";
import {DeleteDialog} from "../../../_metronic/_partials/controls/delete-modal/DeleteDialog";
import SnackbarCmp from "../../../_metronic/_partials/controls/feedback/Snackbar";
import {useOrdersUIContext} from "./OrdersUIContext";
import {shallowEqual, useSelector} from "react-redux";

export default function OrdersListCmp() {

    const orderContext = useOrdersUIContext();

    const {actionsLoading} = useSelector(
        (state) => ({
            actionsLoading: state.actionsLoading.actionsLoading,
        }),
        shallowEqual
    );

    useEffect(() => {
        orderContext.fetchData();
    }, []);

    const handleDelete = () => {
        // deleteProduct(orderContext.id).then(() => {
        //     orderContext.setOpenDelete(false);
        //     orderContext.fetchData();
        // }).catch(() => {
        //     orderContext.setOpenDelete(false);
        //     orderContext.setOpenError(true);
        //     orderContext.setError("Something went wrong!");
        // });
    };

    return (
        <>
            {actionsLoading && <ModalProgressBar/>}
            <Card>
                <CardHeader title="لیست سفارشات">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-warning ml-2"
                            onClick={() => {
                                orderContext.fetchData()
                            }}>
                            بارگزاری مجدد
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>

                    <OrdersTable orders={orderContext.orders}/>

                    {orderContext.openDelete &&
                    <DeleteDialog
                        show={orderContext.openDelete}
                        onHide={() => {
                            orderContext.setOpenDelete(false);
                            orderContext.fetchData();
                        }}
                        handleDelete={handleDelete}
                    />
                    }

                    {orderContext.openError &&
                    <SnackbarCmp message={orderContext.error} onClose={() => orderContext.setOpenError(false)}/>
                    }

                </CardBody>
            </Card>
        </>
    )
}